import * as React from 'react';

const AlignTop = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 1H1V2.2H19V1ZM9.4 4.6H4.6V19H9.4V4.6ZM15.4 4.6H10.6V14.2H15.4V4.6Z" fill="currentColor"/>
  </svg>
);

export default AlignTop;
